export const defaultTagValues: string[] = [
    'AZ AG',
    'PACT ACT',
    'RBI', 
    'ANJ'
]